require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-javascript-algorithms-and-data-structures-projects-roman-numeral-converter.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-javascript-algorithms-and-data-structures-projects-roman-numeral-converter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-javascript-algorithms-and-data-structures-projects-roman-numeral-converter!./.cache/json/javascript-algorithms-and-data-structures-javascript-algorithms-and-data-structures-projects-roman-numeral-converter.json
// module id = 2438
// module chunks = 231608221292675